import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { Flame, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8" data-testid="forgot-password-logo">
          <span className="w-9 h-9 rounded-md bg-primary flex items-center justify-center"><Flame className="w-5 h-5 text-white" /></span>
          <span className="font-display text-xl font-bold">DealWisp</span>
        </Link>
        <div className="bg-card border border-white/10 rounded-2xl p-8">
          {sent ? (
            <>
              <h1 className="font-display text-2xl font-bold tracking-tight">Check your email</h1>
              <p className="text-sm text-muted-foreground mt-2" data-testid="forgot-password-sent">
                If an account exists for <strong className="text-foreground">{email}</strong>, we've sent a link to reset your password.
              </p>
            </>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold tracking-tight">Reset your password</h1>
              <p className="text-sm text-muted-foreground mt-1">We'll email you a link to set a new one.</p>

              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label className="overline text-muted-foreground">Email</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@shop.com" data-testid="forgot-password-email" className="mt-2 bg-background border-white/10" />
                </div>
                {error && <p className="text-sm text-primary" data-testid="forgot-password-error">{error}</p>}
                <Button type="submit" disabled={loading} className="w-full rounded-full bg-primary hover:bg-secondary" data-testid="forgot-password-submit">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
                </Button>
              </form>
            </>
          )}

          <p className="mt-6 text-sm text-center text-muted-foreground">
            <Link to="/login" className="text-primary hover:underline" data-testid="forgot-password-to-login">Back to log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
